import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { useMessageBus } from "@jti/fe-message-bus";
import { getParams } from "../../../../utils/getParams";
import { setParams } from "../../../../utils/setParams";
import { SearchForm } from "../SearchForm";
import styles from "./SearchBox.module.scss";
export const SearchBox = ({ translations, resultsPage, navigationFn }) => {
    const messageBus = useMessageBus();
    const [searchText, setSearchText] = useState(null);
    const [totalResults, setTotalResults] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const searchTitle = useMemo(() => {
        if (translations?.searchResultsLabel && searchText) {
            return translations?.searchResultsLabel?.replace("{query}", searchText);
        }
        return translations?.title;
    }, [translations.title, translations?.searchResultsLabel, searchText]);
    const handleSearchSubmit = (searchValue) => {
        setSearchText(searchValue);
        setParams({ q: searchValue });
        messageBus.publish("search.value", { payload: { searchValue } });
    };
    useEffect(() => {
        const query = getParams("q")?.q;
        if (query) {
            setSearchText(query);
        }
        messageBus.subscribe({
            channel: "search.total.results",
            callback({ payload: { searchTotalResults, isResultsLoading } }) {
                setTotalResults(searchTotalResults);
                setIsLoading(isResultsLoading);
            },
        });
        return () => {
            messageBus.unsubscribe("search.total.results");
        };
    }, [messageBus]);
    return (_jsx("div", { className: styles.container, children: _jsxs("div", { className: styles.searchWrapper, "data-testid": "searchWrapper", children: [searchTitle && (_jsx("div", { className: styles.searchText, "data-testid": "searchTitle", children: searchTitle })), _jsx(SearchForm, { translations: translations, isInputAutoFocus: false, initialSearchValue: searchText, resultsPage: resultsPage, onSearchSubmit: handleSearchSubmit, navigationFn: navigationFn }), searchText && !isLoading && (_jsx("div", { className: styles.totalResults, "data-testid": "searchTotalResults", children: translations.resultsLabel?.replace("{count}", String(totalResults ?? 0)) }))] }) }));
};
//# sourceMappingURL=SearchBox.js.map